import { BaseComponent } from '../models/components/BaseComponent';

export function getComponentFromSource<T extends BaseComponent>(className: string, components: Array<BaseComponent>): T {

    let component = components.filter(componentIntern => {
        return componentIntern.componentType == className; }
        )[0] || null;
    // cast the component to conrecte type T.
    let result = component as T;

    return result;
}

export function getComponentsFromSource<T extends BaseComponent>(className: string, components: Array<BaseComponent>): Array<T> {

    let componentArray = components.filter(componentIntern => {
        return componentIntern.componentType == className; }
        );
    // cast the component to conrecte type T.
    let result = componentArray as Array<T>;

    return result;
}